const React = require('react')
const PropTypes = require('prop-types')
const isAllowedFeature = require('module/user/helpers/is_allowed_feature')
const hasFeature = require('module/user/helpers/has_feature')
const FacebookVideo = require('./video_facebook')
const NfuszVideo = require('./video_nfusz')
const VimeoVideo = require('./video_vimeo')
const YoutubeVideo = require('./video_youtube')
const PlaceholderVideo = require('./video_placeholder')
const { isVideoType } = require('lib/video')
const log = require('log').create('profile', 'video') // eslint-disable-line

/*

facebook example
https://www.facebook.com/natgeo/videos/vl.1887467314909998/10154808512288951

vimeo example
https://vimeo.com/260757651

youtube example
https://www.youtube.com/watch?v=U2ncacVObN4

nfusz example
https://app.nfusz.com/player/5icx0cde

*/

function Video({ user, nested }) {

    // don't render if user is not allowed this feature
    // e.g. an expired pro user
    if (! isAllowedFeature(user, 'video')) return null

    // don't render if they don't have it configured
    if (! hasFeature(user, 'video')) return null

    const { video } = user

    // don't render unsupported video types
    if (! isVideoType(video.type)) return null

    // show video placeholder in nested profiles
    if (nested) {
        return (
            <section className="video">
                <PlaceholderVideo video={video} />
            </section>
        )
    }

    return (
        <section className="video inset">
            <FacebookVideo video={video} />
            <NfuszVideo video={video} />
            <VimeoVideo video={video} />
            <YoutubeVideo video={video} />
        </section>
    )
}

Video.propTypes = {
    user: PropTypes.object.isRequired,
    nested: PropTypes.bool,
}

Video.defaultProps = {
    nested: false,
}

module.exports = Video
